
<loader-container
  [loader]="loader"
  [options]="{
      contentTemplate: manage
    }"
  (loaded)="onLoadChatbot($event)"
></loader-container>


<ng-template #manage>
  <quick-preview-panel
    *ngIf="chatbot && form"
    [heading]="chatbot.name + ' Settings'"
    [color]="form.valid ? 'primary' : 'warn'"
  >
    <div class="p-3 pt-4" [formGroup]="form">
      <div class="row p-0 m-0">
        <div
          [ngClass]="'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 m-0 p-0 pe-2 mb-2'"
        >
          <mat-form-field class="d-block">
            <mat-label>Use Session History</mat-label>
            <mat-select
              class="d-block"
              formControlName="useSessionHistory">
              <mat-option [value]="false">No</mat-option>
              <mat-option [value]="true">Yes</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          [ngClass]="'col-12 col-xs-12 col-sm-12 col-md-8 col-lg-6 col-xl-4 m-0 p-0 pe-2 mb-2'"
        >
          <mat-form-field class="d-block">
            <mat-label>History Cap</mat-label>
            <input type="number" matInput
                   placeholder="Maximum messages remembered by the assitant"
              formControlName="maxSessionHistorySize"
            >
            <mat-error>
              Required field
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div [formGroup]="settingsGroup">
        <div class="row p-0 m-0 pb-2" *ngFor="let k of ragSearchConfigKeys"
          [formGroupName]="k">
          <div class="fw-light">Variable "{{k}}"</div>
          <div class="alert alert-warning mt-2" *ngIf="isRagSearchDisabled(k)">
            Variable <b>{{k}}</b> will be excluded from RAG context.
          </div>
          <div class="row p-0 m-0 mt-2 ps-4">
            <div
              [ngClass]="'col-12 col-md-6 3 m-0 p-0 pe-2 mb-2'">
              <mat-form-field class="d-block">
                <mat-label>Disabled</mat-label>
                <mat-select
                  class="d-block"
                  formControlName="disabled">
                  <mat-option [value]="false">No</mat-option>
                  <mat-option [value]="true">Yes</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div
              [ngClass]="'col-12 col-md-6 3 m-0 p-0 pe-2 mb-2'"
            >
              <mat-form-field class="d-block">
                <mat-label>RAG Min Search Score</mat-label>
                <input type="number" matInput class="d-block"
                       formControlName="ragMinSearchScore">
                <mat-error>Required field</mat-error>
              </mat-form-field>
            </div>
            <div formGroupName="searchConfig" class="row p-0 m-0">
              <div
                [ngClass]="'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 m-0 p-0 pe-2 mb-2'"
              >
                <mat-form-field class="d-block">
                  <mat-label>Limit</mat-label>
                  <input type="number" matInput class="d-block"
                         formControlName="limit">
                  <mat-error>Required field</mat-error>
                </mat-form-field>
              </div>
              <div
                [ngClass]="'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 m-0 p-0 pe-2 mb-2'"
              >
                <mat-form-field class="d-block">
                  <mat-label>Metric Type</mat-label>
                  <mat-select formControlName="metric_type" class="d-block">
                    <mat-option [value]="'COSINE'">Cosine Similarity (COSINE)</mat-option>
                    <mat-option [value]="'IP'">Inner Product (IP)</mat-option>
                    <mat-option [value]="'L2'">Euclidean Distance (L2)</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div
                [ngClass]="'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-6 m-0 p-0 pe-2 mb-2'"
              >
                <mat-form-field class="d-block">
                  <mat-label>Output Field</mat-label>
                  <input type="text" matInput class="d-block"
                         formControlName="output_fields_text">
                </mat-form-field>
              </div>
            </div>

          </div>
        </div>
      </div>
      <actions-container>
        <back-button></back-button>
        <button
          [disabled]="!form.valid"
          color="primary"
          mat-raised-button
          (click)="save()"
        >
          <mat-icon class="valign-middle">save</mat-icon>
          Save
        </button>

      </actions-container>
    </div>
  </quick-preview-panel>
</ng-template>
